import React, { Component } from 'react';
import './App.css'
import Image from "react-graceful-image";

import artwork from './images/sound-of-a-distant-wave.jpg'

class SoundOfADistantWaveSmartLinks extends Component {
	render() {
		return (
			<div className="Smart-links">
				<a href="https://sheepdogwolf.bandcamp.com/track/sound-of-a-distant-wave"><Image src={artwork} noLazyLoad="true" placeholderColor="#000" className="Smart-link-single-artwork" /></a>
				<div className="Smart-link-buttons">
					<a href="https://sheepdogwolf.bandcamp.com/track/sound-of-a-distant-wave"><btn className="Smart-link-button">bandcamp</btn></a>
					<a href="https://open.spotify.com/album/2wkm5KegcXmnkTPeSCEdb2"><btn className="Smart-link-button">spotify</btn></a>
					<a href="https://music.apple.com/nz/album/sound-of-a-distant-wave-single/1819243238"><btn className="Smart-link-button">apple music</btn></a>
					<a href="https://youtu.be/VDPCMySrgaY"><btn className="Smart-link-button">youtube</btn></a>
					<a href="https://tidal.com/album/440622215"><btn className="Smart-link-button">tidal</btn></a>
				</div>
			</div>
		);
	}
}

export default SoundOfADistantWaveSmartLinks;